"use client";

/**
 * Last-resort boundary for a throw in the ROOT layout itself, which app/error.tsx
 * cannot catch — it lives inside that layout. Next replaces the whole document
 * here, so this file owns <html>/<body> and cannot rely on globals.css having
 * been applied; the styles are inline for that reason, not by preference.
 */

import { useEffect } from "react";
import { getRumClient } from "@juiceco-io/observability-sdk/react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    getRumClient()?.recordError(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          // Literal values of --paper / --ink from globals.css, which is not
          // guaranteed to be applied on this path.
          background: "#f6f5f2",
          color: "#16202e",
          fontFamily: "Georgia, 'Times New Roman', serif",
        }}
      >
        <div style={{ margin: "0 auto", maxWidth: "40rem", padding: "0 1.5rem" }}>
          <h1 style={{ fontSize: "2rem", fontWeight: 600, lineHeight: 1.15, margin: 0 }}>
            This page didn&rsquo;t load.
          </h1>
          <p style={{ marginTop: "1rem", fontSize: "1.05rem", color: "#3a4656" }}>
            The problem has been reported.{" "}
            <a href="/" style={{ color: "#8c6520" }}>
              Back to the homepage
            </a>
            .
          </p>
          {error.digest && (
            <p
              style={{
                marginTop: "2rem",
                fontFamily: "ui-monospace, monospace",
                fontSize: "0.7rem",
                color: "#3a4656",
              }}
            >
              Reference: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
